import React from 'react';
import ProductImage from '../ProductImage';
import Icon from '../Icon';

function ProductCard({ product, groups, onEdit, onDelete }) {
  const stock = (product.variants || []).reduce(
    (sum, variant) => sum + variant.stock,
    0
  );
  const prices = (product.variants || [])
    .map((v) => v.price)
    .filter((price) => price > 0);
  const available = product.variants?.some((v) => v.stock > 0 && v.price > 0);

  return (
    <div className="seller-product-row">
      <ProductImage product={product} width={56} height={74} zoom />
      <div className="seller-product-info">
        <strong>{product.title}</strong>
        <div style={{ fontSize: 13, color: '#64748b' }}>
          Арт. МП: {product.publicArticle || product.platformSku} | Арт. прод.: {product.sellerSku}
        </div>
        {product.brand && (
          <div style={{ fontSize: 13 }}>Бренд: {product.brand}</div>
        )}
        {product.color && (
          <div style={{ fontSize: 13 }}>Цвет: {product.color}</div>
        )}
        {product.subcategory && (
          <div style={{ fontSize: 13 }}>
            Подкатегория: {product.subcategory}
          </div>
        )}
        {product.groupId && (
          <div style={{ fontSize: 13, color: '#7C3AED' }}>
            Группа:{' '}
            {groups.find((g) => g.id === product.groupId)?.name ||
              product.groupId}
          </div>
        )}
      </div>
      <div className="seller-product-numbers">
        <strong>
          {prices.length
            ? `от ${Math.min(...prices).toLocaleString('ru-RU')} ₽`
            : 'Без цены'}
        </strong>
        <small>
          {stock} шт. · {product.variants?.length || 0} SKU
        </small>
        <span className={`seller-status ${available ? 'is-active' : ''}`}>
          {available ? 'В продаже' : 'Не в продаже'}
        </span>
      </div>
      <div className="seller-row-actions">
        <button onClick={() => onEdit(product)} className="btn btn-outline">
          <Icon name="edit" size={16} />
          <span>Редактировать</span>
        </button>
        <button
          onClick={() => onDelete(product.id)}
          className="seller-delete"
          aria-label={`Удалить товар ${product.title}`}
        >
          <Icon name="trash" size={18} />
        </button>
      </div>
    </div>
  );
}

export default ProductCard;
